/** Defines valid line item types. */
enum LineItemType {
  Product = 'Product',
  GiftCard = 'GiftCard',
  Custom = 'Custom'
}

export default LineItemType;
